<div class="feature-card">
  <div class="feature-card-img">
    <img src="{{ featureImage }}" alt="{{featureImageAltText}}" />
  </div>
  <div class="feature-card-content">
    <ng-content></ng-content>
  </div>
</div>